import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Portfolio, Storage } from 'actions';
import { Header, Segment, Button } from 'components';
import { Flag, Icon, Popup } from 'semantic-ui-react';
import cn from 'classnames';
import { colors } from 'utils/colors';
import { translation } from '../modules/Translation/accounts';

export default function CashAnalyze({
  dispatch,
  holdings,
  analyze,
  hasNegativeWeights,
  isNegativePort,
  language,
  hasCurrencyOption,
}) {
  return (
    <div style={{ height: '100%', width: '100%' }}>
      <Segment flex margin="2rem 3rem 2rem 3rem" style={{ minHeight: '85vh' }}>
        <div
          style={{
            position: 'relative',
            alignContent: 'center',
            padding: '4rem',
          }}
        >
          <Header size="1.5rem" color="black">
            {translation[language].CASHANALYZE_HEADER}
          </Header>
          <P>
            {translation[language].CASHANALYZE_P1}
            <Popup
              trigger={
                <Icon
                  name="question circle outline"
                  style={{
                    fontSize: '15px',
                    verticalAlign: 'initial',
                    color: 'dimgrey',
                  }}
                />
              }
              position="top center"
              wide
              content={<span>{translation[language].CASHANALYZE_P2}</span>}
            />
          </P>
          {hasCurrencyOption ? (
            <CurrencyOption>
              <StyledButton
                className={cn('basic', {
                  disabled: isNegativePort,
                })}
                color={colors.darkBlue}
                onClick={() => {
                  analyze(holdings);
                  dispatch(Storage.setItem('toggle_region', 'US'));
                  dispatch(Portfolio.notSaveUrlSc());
                }}
              >
                <div className="flag">
                  <Flag
                    name="us"
                    style={{ height: 'inherit', marginLeft: '0.8em' }}
                  />
                </div>
                <div style={{ marginLeft: '36px' }}>
                  {translation[language].CASHANALYZE_ANALYZEUSD}
                </div>
              </StyledButton>
              <StyledButton
                className={cn('basic', {
                  disabled: isNegativePort,
                })}
                color={colors.darkBlue}
                onClick={() => {
                  analyze(holdings);
                  dispatch(Storage.setItem('toggle_region', 'CA'));
                  dispatch(Portfolio.notSaveUrlSc());
                }}
              >
                <div className="flag">
                  <Flag
                    name="ca"
                    style={{ height: 'inherit', marginLeft: '0.8em' }}
                  />
                </div>
                <div style={{ marginLeft: '36px' }}>
                  {translation[language].CASHANALYZE_ANALYZECAD}
                </div>
              </StyledButton>
            </CurrencyOption>
          ) : (
            <Button
              className={cn('left', {
                disabled: isNegativePort,
              })}
              icon="line chart"
              color={colors.darkBlue}
              onClick={() => {
                analyze(holdings);
                dispatch(Portfolio.notSaveUrlSc());
              }}
              style={{ marginTop: '3rem' }}
            >
              {translation[language].CASHANALYZE_ANALYZE}
            </Button>
          )}
          {hasNegativeWeights ? (
            isNegativePort ? (
              <Message>
                <Icon name="warning sign" style={{}} />
                {translation[language].WARNING_NEGATIVEPORT}
              </Message>
            ) : (
              <Message>
                <Icon name="warning sign" style={{}} />
                {translation[language].WARNING_SHORTPOSITIONS}
              </Message>
            )
          ) : null}
        </div>
      </Segment>
    </div>
  );
}

CashAnalyze.propTypes = {
  dispatch: PropTypes.func,
  holdings: PropTypes.object,
  analyze: PropTypes.func,
  hasNegativeWeights: PropTypes.bool,
  isNegativePort: PropTypes.bool,
  language: PropTypes.string,
  hasCurrencyOption: PropTypes.bool,
};

CashAnalyze.defaultProps = {
  dispatch: () => {},
  holdings: {},
  analyze: () => {},
  hasNegativeWeights: false,
  isNegativePort: false,
  language: 'en',
  hasCurrencyOption: false,
};

const P = styled.p`
  color: rgba(0, 0, 0, 0.5) !important;

  &.strike {
    text-decoration: line-through;
  }
`;

const Message = styled.p`
  color: ${colors.red};
  font-weight: bold;
  margin-top: 1em;
`;

const CurrencyOption = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 10px;
  justify-content: center;
  margin-top: 3rem;
`;

const StyledButton = styled(Button)`
  position: relative;
  border-radius: 4px;
  box-shadow: 0 0 0 1px rgba(34, 36, 38, 0.15) inset;
  font-size: 0.9rem;
  min-height: 1em;
  min-width: 110px;
  height: 36px;
  border: none;
  text-align: center;
  outline: 0;
  transition: all 0.3s ease;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.6);
  background-color: transparent;
  vertical-align: top;
  line-height: 36px !important;
  user-select: none !important;
  margin-top: 5px !important;
  background-color: white;
  &:hover {
    box-shadow: inset 0 0 0 1.5px ${colors.darkBlue} !important;
    color: rgba(0, 0, 0, 0.6);
  }
  .flag {
    height: 100%;
    position: absolute;
    color: white;
    top: 0;
    left: 0;
    width: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${colors.darkBlue};

    &:before {
      position: absolute;
      line-height: 1;
      font-size: 1em;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
